import { connect } from 'react-redux';

import { iRootDispatch, iRootState } from '../../store';
import { AvailableBrokersAndEstatesState } from '../../store/types/temp-types';
import CanceledBondInsurances from './CanceledBondInsurances';

export type { BondInsuranceListProps } from './CanceledBondInsurances';

const mapState = (state: iRootState) => ({
  availableBrokersAndEstates: state.availableBrokersAndEstates,
  user: state.user
});

const mapDispatch = (dispatch: iRootDispatch) => ({
  updateAvailableBrokersAndEstates: (availableBrokers: AvailableBrokersAndEstatesState) =>
    dispatch.availableBrokersAndEstates.updateAvailableBrokersAndEstates(availableBrokers)
});

export default connect(mapState, mapDispatch)(CanceledBondInsurances);
